import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./thankyou.scss";
import snowSledImg from "../../assets/images/thankyou.png";
import Button from "../../components/Button/Button";
import { formatCurrency } from "../../utility/UtilityFuncs";
const ThankYou = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const payWithCreditCard = queryParams.get("payWithCreditCard") === "true";
  const orderId = queryParams.get("orderId");
  const grandTotal = queryParams.get("grandTotal");
  const navigate = useNavigate();
  if (!payWithCreditCard) {
    return (
      <div className="content-container">
        <div className="etransfer thank-you-container">
          <header>
            <h1 className="display-font">We are saving some trees for you!</h1>
            <h3 className="bold">Order Confirmation Number: {orderId}</h3>
          </header>
          <img
            className="__thankyou-img"
            src={snowSledImg}
            alt="sledding tao and aaron"
          />
          <div className="text-container">
            <h4>Only one more step to fruit bearing bliss!</h4>
            <h3>
              To complete the order, please send an etransfer of{" "}
              <span className="dollar-total">{formatCurrency(grandTotal)}</span>{" "}
              to maplegrovepermaculture@gmail.com.
            </h3>
            <p>
              As soon as we can confirm payment, you can expect a confirmation
              email filled with gracious thanks and tips for prep and planting!
            </p>
            <p>
              If payment isnt received within 4 days, the order will sadly be
              cancelled.
              <br /> If you have any questions about the process or your
              purchase, you can email us at{" "}
              <span className="bold">maplegrovepermaculture@gmail.com</span>
            </p>
            <Button onClick={() => navigate("/store")}>Return to Shop</Button>
          </div>
        </div>
      </div >
    );
  } else {
    return (
      <div className="content-container">
        <div className="etransfer thank-you-container">
          <h1>Thank you for your purchase!</h1>
          <h3 className="bold">Order Confirmation Number: {orderId}</h3>
          <img
            className="__thankyou-img"
            src={snowSledImg}
            alt="sledding tao and aaron"
          />
          <p>
            What's next?
            <br />
            <br />
            Pickup ► Prep ► Plant ► Parent ► Prosper!
            <br />
            <br /> Right around now, you should be getting an order confirmation
            email filled with even more gracious thanks and a receipt for this
            purchase.
            <br />
            <br />
            If you have any questions about the process or your purchase, you
            can reach Aaron over email at maplegrovepermaculture@gmail.com
          </p>
          <Button onClick={() => navigate("/store")}>Return to Shop</Button>
        </div>
      </div>
    );
  }
};
export default ThankYou;
